import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-breadcrumb',
  templateUrl: './demo-breadcrumb.component.html',
  styleUrls: ['./demo-breadcrumb.component.less']
})
export class DemoBreadcrumbComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
